export const GET_USER_INFO = 'GET_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_PROFILE_IMAGE_BLOBURL = 'UPDATE_PROFILE_IMAGE_BLOBURL';
export const UPDATE_USER_NOTIFICATION_PREFERENCES =
  'UPDATE_USER_NOTIFICATION_PREFERENCES';
export const UPDATE_FULL_SCREEN_PROP = 'UPDATE_FULL_SCREEN_PROP';
export const SET_INPUT_INTRO = 'SET_INPUT_INTRO';
export const TETRA_ANIMATION = 'TETRA_ANIMATION';
